import { FC } from 'react'

import {
  FormControl,
  FormControlProps,
} from '@tribeplatform/react-ui-kit/FormControl'

import { MemberPicker, MemberPickerProps } from './MemberPicker.js'
import { SpacePicker, SpacePickerProps } from './SpacePicker.js'
import { TagPicker, TagPickerProps } from './TagPicker.js'

export const PickerFormControl = ({ children }) => (
  <div className="space-y-1">{children}</div>
)

export type PickerFormControlSpaceProps = FormControlProps & SpacePickerProps

export const PickerFormControlSpace: FC<
  PickerFormControlSpaceProps
> = props => {
  const { name, label, helperText, error, invalid, onChange, value, ...rest } =
    props
  return (
    <div>
      {label ? (
        <FormControl.Label htmlFor={name}>{label}</FormControl.Label>
      ) : null}
      <div className="mt-1">
        <SpacePicker
          {...rest}
          value={value as any}
          onChange={onChange as any}
        />
        <FormControl.Meta
          {...{
            helperText,
            error,
            invalid,
          }}
        />
      </div>
    </div>
  )
}

export type PickerFormControlMemberProps = FormControlProps & MemberPickerProps

export const PickerFormControlMember: FC<
  PickerFormControlMemberProps
> = props => {
  const { name, label, helperText, error, invalid, onChange, value, ...rest } =
    props
  return (
    <div>
      {label ? (
        <FormControl.Label htmlFor={name}>{label}</FormControl.Label>
      ) : null}
      <div className="mt-1">
        <MemberPicker
          {...rest}
          value={value as any}
          onChange={onChange as any}
        />
        <FormControl.Meta
          {...{
            helperText,
            error,
            invalid,
          }}
        />
      </div>
    </div>
  )
}

export type PickerFormControlTagProps = FormControlProps & TagPickerProps

export const PickerFormControlTag: FC<PickerFormControlTagProps> = props => {
  const { name, label, helperText, error, invalid, onChange, value, ...rest } =
    props
  return (
    <div>
      {label ? (
        <FormControl.Label htmlFor={name}>{label}</FormControl.Label>
      ) : null}
      <div className="mt-1">
        <TagPicker {...rest} value={value as any} onChange={onChange as any} />
        <FormControl.Meta
          {...{
            helperText,
            error,
            invalid,
          }}
        />
      </div>
    </div>
  )
}

PickerFormControl.SpacePicker = PickerFormControlSpace
PickerFormControl.MemberPicker = PickerFormControlMember
PickerFormControl.TagPicker = PickerFormControlTag
